import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=f5945d64&scoped=true"
var script = {}
import style0 from "./Empty.vue?vue&type=style&index=0&id=f5945d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5945d64",
  null
  
)

export default component.exports